import { createSlice } from "@reduxjs/toolkit";
import { logout } from "./store-actions";
import { baseApi } from "./store-query";
import { Account } from "apis/types/account";
import accountApi from "apis/services/accountService";

type InitialState = {
  authUser: Account | null;
  isSideNavigation: boolean;
  isLoadingModal: boolean;
};

export const initialState: InitialState = {
  authUser: null,
  isSideNavigation: false,
  isLoadingModal: false,
};

export const slice = createSlice({
  name: "global",
  initialState: initialState,
  reducers: {
    setAuthUser: (state, { payload }) => {
      state.authUser = payload;
    },
    toggleSideNavigation: (state, { payload }) => {
      state.isSideNavigation =
        payload !== undefined ? !!payload : !state.isSideNavigation;
    },
    toggleLoadingModalAction: (state, { payload }) => {
      state.isLoadingModal =
        payload !== undefined ? !!payload : !state.isLoadingModal;
    },
  },
  extraReducers: (builder) =>
    builder
      .addCase(logout, () => ({ ...initialState }))
      .addMatcher(
        accountApi.endpoints.loginAccount.matchFulfilled,
        (state, { payload }) => {
          state.authUser = payload.data;
        }
      ),
});

export const { toggleSideNavigation, toggleLoadingModalAction } = slice.actions;

export default slice;

export function getStorageState({ authUser }: InitialState) {
  return { authUser };
}
